import { render, staticRenderFns } from "./RoutineApprovalHistoryDialog.vue?vue&type=template&id=7b74a824"
import script from "./RoutineApprovalHistoryDialog.vue?vue&type=script&lang=js"
export * from "./RoutineApprovalHistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./RoutineApprovalHistoryDialog.vue?vue&type=style&index=0&id=7b74a824&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports